import { GetCurrentWebUserResponseDTO, WorkspaceDTO } from '@gearbelt/global';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface UserStore {
  user: GetCurrentWebUserResponseDTO | null;
  org: WorkspaceDTO | null;
  isNewUser: boolean;
  hasMultipleWorkspaces: boolean;
  setUser: (arg0: GetCurrentWebUserResponseDTO | null) => void;
  setOrg: (arg0: WorkspaceDTO | null) => void;
}

export const useUserStore = create<UserStore>()(
  persist(
    (set) => ({
      user: null,
      org: null,
      isNewUser: false,
      hasMultipleWorkspaces: false,
      setUser: (user: GetCurrentWebUserResponseDTO | null) =>
        set(() => {
          if (user) {
            const sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
            const userCreatedAt = new Date(user.createdAt);

            const isWithinGracePeriod = userCreatedAt > sevenDaysAgo;
            const hasWorkspaces = user.workspaces?.length > 0;
            const hasMultipleWorkspaces = user.workspaces?.length > 1;

            return { user, isNewUser: isWithinGracePeriod && !hasWorkspaces, hasMultipleWorkspaces };
          }
          return { user: null, isNewUser: false, hasMultipleWorkspaces: false };
        }),
      setOrg: (org: WorkspaceDTO | null) => set(() => ({ org })),
    }),
    {
      name: 'gb-user',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
useUserStore.setState((state) => ({ ...state }));

// The identifier sent as the `x-workspace-id` header (see api-v2 beforeRequest). Workspace-scoped
// query keys must include it so a workspace switch doesn't serve the previous workspace's cache.
export const getActiveWorkspaceId = () => useUserStore.getState().org?.id;
